// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Form, FormGroup, Label } from "@components";
import { Dropdown } from "@components/form";
import { Field, reduxForm } from "redux-form";
import type { FormProps } from "redux-form";

type OwnProps = $Exact<{
  handleSubmit: Function,
  onReset: Function,
  filterOptions: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AbsenceReasonsFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.onReset();
  };

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit} className="d-flex mx-5 mt-5">
        <FormGroup className="mr-3 col-2">
          <Label for="absenceType">{this.props.t("ABSENCE_TYPE")}</Label>
          <Field
            id="absenceType"
            name="section"
            className="w-100"
            placeholder={this.props.t("ALL")}
            component={Dropdown}
            options={this.props.filterOptions.absenceType}
          />
        </FormGroup>
        <FormGroup className={"d-flex align-items-end form-group col-3 px-2"}>
          <Button>{this.props.t("APPLY_FILTER")}</Button>
          {this.props.dirty ? (
            <Button color="secondary" onClick={this.resetForm}>
              {this.props.t("RESET")}
            </Button>
          ) : null}
        </FormGroup>
      </Form>
    );
  }
}

export default reduxForm({
  form: "absence-reasons-filters",
})(localize()(AbsenceReasonsFilter));
